import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import logo from './logos/Pagination_Logo_scritta_bianco_noDotCom.svg'
import DashboardHeader from './components/utility/DashboardHeader'
import DashboardSidebar from './components/utility/DashboardSidebar'
import Toolbar from '@mui/material/Toolbar';
import Primarytheme from './components/utility/theme';
import ServiceContext from './components/utility/ServiceContext';
import CssBaseline from "@mui/material/CssBaseline";

import ChangePassword from './components/auth/ChangePassword';
import ForgotPasswordConfirm from './components/auth/ForgotPasswordConfirm';
import FirstLogin from './components/auth/FirstLogin';
import ForgotPassword from './components/auth/ForgotPassword';
import ForgotPasswordVerification from './components/auth/ForgotPasswordVerification';
import Notfound from './components/utility/Notfound';
import Login from './components/auth/Login';

import PaginationAPI from './components/PaginationAPI';
import History from './components/History';

import Navbar from './components/utility/Navbar';

import Dashboard from './components/Dashboard';
import Administration from './components/Administration';
import Billing from './components/Billing';
import Stats from './components/Stats';
import Charts from './components/Charts';
import AssetManagement from './components/AssetManagement';
// import Tools from './components/Tools';
import Traffic from './components/Traffic';
import GeoxRulesPage from './components/utility/GeoxRulesPage';

import ErrorBoundary from './components/utility/ErrorBoundary';

import LoadingPage from './components/utility/LoadingPage';

import { config as AWSconfig, SSM, S3, CognitoIdentityCredentials } from 'aws-sdk';
import ProjectInfo from './components/ProjectInfo';
import Integrations from './components/Integrations';
import Labels from './components/Labels';

import { getSessionIdToken } from './components/auth/apiAuth'

//const axios = require('axios');
import axios from 'axios';
AWSconfig.update({ region: 'eu-west-1' });


const { buildUsernameFromEmail } = require('./components/auth/utils-auth');

const paramIds = [
  `/web-app/USER_ID`,
  `/web-app/USER_POOL_ID`,
  `/web-app/IDENTITY_POOL_ID`,
  `/web-app/APP_CLIENT_ID`,
  `/web-app/S3_BUCKET`,
];


const autorefreshAuthInterval = 3600000 //[ms] ogni ora

const {
  REACT_APP_USER_ID,
  REACT_APP_USER_POOL_ID,
  REACT_APP_API_BASE_URL
} = process.env;


export default function App() {
  const theme = useTheme();

  const [userState, setUserState] = useState({
    isAuthenticated: false,
    isAuthenticating: true,
    isFetching: true,
    isConfirmed: false,
    isAdmin: false,
    user: null,
    lastLogin: null,
    email: null,
    projects: [],
    customer: null,
    userItem: null,
    attached_projects: [],
    all_attached_projects: [],
    api_project_ids: [],
    active_project_ids: [],
    attached_labels_projects: [],
    ssmParams: null,
    custom_message: null,
    type: null
  })


  const setAWStempCredentials = (JWTaccessToken) => {
    const LoginsObj = {};
    AWSconfig.update({ region: 'eu-west-1' });
    LoginsObj[`cognito-idp.eu-west-1.amazonaws.com/${process.env.REACT_APP_USER_POOL_ID}`] = JWTaccessToken;
    AWSconfig.update({
      credentials: new CognitoIdentityCredentials({
        IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
        Logins: LoginsObj
      })
    });
    AWSconfig.credentials.clearCachedId();

    return new Promise((resolve, reject) => {
      AWSconfig.credentials.refresh(err => {
        if (err) reject(err)
        else resolve("Successful login")
      });
    })
    /*     AWSconfig.credentials.refresh(err => {
          if (err) console.error(err)
          else console.log("Successful login")
        });
        AWSconfig.getCredentials((err) => {
          if (err) {
            console.log(err);
            console.log(err.originalError)
          }
        }); */

  }


  const fetchDynamoUser = async ({ username }) => {
    return axios({
      method: "get",
      url: `${process.env.REACT_APP_API_BASE_URL}/users`,
      headers: {
        "user_id": 'web-app',
        "userinfo_id": username,
        "content-type": "application/json",
        "Authorization": await getSessionIdToken()
      }
    })
  }


  const refreshAuthentication = async () => {
    //console.log('refresh auth')
    const currentAuthPromises = [
      fetchAuthSession(),
      getCurrentUser()
    ]
    return Promise.all(currentAuthPromises)
      .then(async ([session, user]) => {
        //console.log('curren authenticated user ', user, session)
        await setAWStempCredentials(`${session.tokens.idToken}`);
        //console.log('credenziali recuperate', AWSconfig.credentials);

        const ssmClient = new SSM();
        const ssmParamsPromises = paramIds.map((param) =>
          ssmClient.getParameter({
            Name: param,
            WithDecryption: true,
          }).promise().catch(error => {
            console.error(`error retrieving-params`);
            return null;
          })
        )
        return Promise.all([
          user,
          Promise.all(ssmParamsPromises)
          // SSMPARAMS
        ]);
      })
      .then(([user, ssmParams]) => {
        const ssmPars = {};
        if (ssmParams.length) ssmParams.forEach(param => param ? ssmPars[param.Parameter.Name.split('/').pop()] = param.Parameter.Value : undefined);
        //console.log('ssm params ', ssmPars)
        // console.log('fetching user ', user.username, ssmPars.X_API_KEY)
        //console.log(user)

        const usernameRaw = (user.signInDetails && user.signInDetails.loginId) ? user.signInDetails.loginId : user.username;
        const user_id = buildUsernameFromEmail(usernameRaw);
        return fetchDynamoUser({ username: user_id })
          .then(dynData => {
            //console.log('fetched user ', dynData)
            const userItem = dynData.data;
            const apiProjectIds = userItem.api_project_ids || [];
            const allAttachedProjects = [...(userItem.attached_projects || [])];
            // Filter userItem so all components reading userItem.attached_projects get webapp-only list
            userItem.attached_projects = allAttachedProjects.filter(p => !apiProjectIds.includes(p));
            const policy = {
              canDelete: true,
              canLaunch: true,
              canManageAsset: true,
              ...userItem.policy
            };
            setUserState(prev => ({
              ...prev,
              isAuthenticated: true,
              user: userItem.user_id,
              email: userItem.email,
              isAuthenticating: false,
              isFetching: false,
              userItem,
              lastLogin: (new Date()).getTime(),
              attached_projects: userItem.attached_projects.sort(),       // standard project (webapp only)
              all_attached_projects: allAttachedProjects.sort(),          // lista completa projects
              api_project_ids: apiProjectIds,                             // solo API projects
              attached_labels_projects: userItem.attached_labels_projects || [],
              customer: userItem.customer,
              isAdmin: userItem.type === 'administrator',
              type: userItem.type,
              ssmParams: ssmPars,
              policy: policy,
              s3: new S3(),
              custom_message: userItem.custom_message
            }))
            return userItem
          })


      })
      .catch(async (err) => {
        console.error('Login failed, please refresh page and try again', err);
        const isAuthError = err?.name === 'NotAuthorizedException' ||
          err?.name === 'UserNotFoundException' ||
          err?.message?.includes('No current user');
        if (isAuthError) {
          await signOut()
          localStorage.clear();
        }
        setUserState(prev => ({
          ...prev,
          isAuthenticating: false,
          isFetching: false,
        }))
      })
  }


  // record last login time
  useEffect(() => {
    if (userState.isAuthenticated) {
      const updateUser = async () => {
        const token = await getSessionIdToken()

        axios.patch(`${process.env.REACT_APP_API_BASE_URL}/users`,
          {
            userInfo_id: buildUsernameFromEmail(userState.email),
            lastLogin: userState.lastLogin,
          },
          {
            headers: {
              'user_id': REACT_APP_USER_ID || userState.ssmParams.USER_ID,
              "content-type": "application/json",
              "Authorization": token
            }
          })
          .catch(() => {})
      }

      updateUser()
    }
  }, [userState.lastLogin])

  // session
  useEffect(() => {
    //console.log('app did mount')
    refreshAuthentication();
  }, []);


  // auto refresh auth
  useEffect(() => {
    function refrhtimer() {
      //console.log('refresh auth');
      refreshAuthentication();
    }
    const intervalRefreshAuth = setInterval(refrhtimer, autorefreshAuthInterval);
    return function cleanup() {
      clearInterval(intervalRefreshAuth);
    }
  }, []);




  const authProps = {
    userState,
    setUserState,
    fetchDynamoUser: fetchDynamoUser,
    refreshAuthentication


  }



  const [isDesktopNavigationExpanded, setIsDesktopNavigationExpanded] =
    React.useState(true);
  const [isMobileNavigationExpanded, setIsMobileNavigationExpanded] =
    React.useState(false);

  const isOverMdViewport = useMediaQuery(theme.breakpoints.up('md'));

  const isNavigationExpanded = isOverMdViewport
    ? isDesktopNavigationExpanded
    : isMobileNavigationExpanded;

  const setIsNavigationExpanded = React.useCallback(
    (newExpanded) => {
      if (isOverMdViewport) {
        setIsDesktopNavigationExpanded(newExpanded);
      } else {
        setIsMobileNavigationExpanded(newExpanded);
      }
    },
    [
      isOverMdViewport,
      setIsDesktopNavigationExpanded,
      setIsMobileNavigationExpanded,
    ],
  );

  const handleToggleHeaderMenu = React.useCallback(
    (isExpanded) => {
      setIsNavigationExpanded(isExpanded);
    },
    [setIsNavigationExpanded],
  );

  const layoutRef = React.useRef(null);

  const [activeService, setActiveService] = React.useState('pagination');
  const serviceContextValue = React.useMemo(() => ({
    activeService,
    setActiveService,
  }), [activeService]);


  return (
    <div className="App">
      <ErrorBoundary>
        <ServiceContext.Provider value={serviceContextValue}>
        <ThemeProvider theme={Primarytheme}>
          <CssBaseline />
          <Router>

            <Switch>


              <Route exact path="/login">
                <PrivateComponent component={<Login auth={authProps} />} redirectPath='dashboard' authProps={authProps} isLogin={true} />
              </Route>

              <Route exact path="/firstlogin">
                <FirstLogin auth={authProps} />
              </Route>

              <Route exact path="/forgotpassword">
                <ForgotPassword />
              </Route>

              <Route exact path="/forgotpasswordverification">
                <ForgotPasswordVerification auth={authProps} />
              </Route>

              <Route exact path="/changepassword">
                <PrivateComponent
                  component={<ChangePassword />}
                  redirectPath="login"
                  authProps={authProps}
                />
              </Route>

              <Route exact path="/forgotpasswordconfirm">
                <ForgotPasswordConfirm auth={authProps} />
              </Route>


              <Route
                path={[
                  "/",
                  "/dashboard",
                  "/history",
                  "/traffic",
                  "/administration",
                  "/billing",
                  "/stats",
                  "/charts",
                  "/assets",
                  "/geoxrules",
                  "/projectinfo",
                  "/integrations",
                  "/pagination-api",
                  "/labels",
                  "/labels/history",
                  "/labels/apikey",
                ]}
              >
                <AppLayout
                  authProps={authProps}
                  isNavigationExpanded={isNavigationExpanded}
                  setIsNavigationExpanded={setIsNavigationExpanded}
                  handleToggleHeaderMenu={handleToggleHeaderMenu}
                  layoutRef={layoutRef}
                >
                  <Switch>

                    <Route exact path="/">
                      <PrivateComponent
                        component={<Redirect to="/dashboard" />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/dashboard">
                      <PrivateComponent
                        component={<Dashboard auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/history">
                      <PrivateComponent
                        component={<History auth={authProps} itemsToShow={12} showFilters />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/projectinfo">
                      <PrivateComponent
                        component={<ProjectInfo auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/traffic">
                      <PrivateComponent
                        onlyAdmin
                        component={<Traffic auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/administration">
                      <PrivateComponent
                        onlyAdmin
                        component={<Administration auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/billing">
                      <PrivateComponent
                        onlyBilling
                        component={<Billing auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/stats">
                      <PrivateComponent
                        onlyBilling
                        component={<Stats auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/charts">
                      <PrivateComponent
                        onlyAdmin
                        component={<Charts auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/assets">
                      <PrivateComponent
                        onlyManageAsset
                        component={<AssetManagement auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/geoxrules">
                      <PrivateComponent
                        onlyGeox
                        component={<GeoxRulesPage auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/integrations">
                      <PrivateComponent
                        onlyManageIntegrations
                        component={<Integrations auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/pagination-api">
                      <PrivateComponent
                        onlyManagePaginationAPI
                        component={<PaginationAPI auth={authProps} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/labels/history">
                      <PrivateComponent
                        onlyManageLabels
                        component={<Labels auth={authProps} initialTab={2} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/labels/apikey">
                      <PrivateComponent
                        onlyManageLabels
                        component={<Labels auth={authProps} initialTab={0} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    <Route exact path="/labels">
                      <PrivateComponent
                        onlyManageLabels
                        component={<Labels auth={authProps} initialTab={1} />}
                        redirectPath="login"
                        authProps={authProps}
                      />
                    </Route>

                    {/* ---- 404 PRIVATA (senza AppLayout esterno) ---- */}
                    <Route path="*">
                      <Notfound />
                    </Route>

                  </Switch>
                </AppLayout>
              </Route>


              {/* ---- 404 GENERALE (FUORI APP LAYOUT) ---- */}
              <Route path="*">
                <Notfound />
              </Route>

            </Switch>
          </Router>
        </ThemeProvider>
        </ServiceContext.Provider>
      </ErrorBoundary>
    </div>
  );

}



function PrivateComponent({ component, redirectPath, authProps, onlyAdmin, onlyBilling, onlyManageAsset, onlyManageIntegrations, onlyManagePaginationAPI, onlyGeox, onlyManageLabels, isLogin = false }) {
  // se sei autenticato, mostra il componente
  if (authProps.userState.isAuthenticated) {
    if (onlyAdmin && !authProps.userState.isAdmin) {
      return <Redirect to={`/`} auth={authProps} />
    } else if (onlyManageAsset && !authProps.userState.policy.canManageAsset) {
      return <Redirect to={`/`} auth={authProps} />
    } else if (onlyManageIntegrations && !authProps.userState.policy.canManageIntegrations && !authProps.userState.isAdmin) {
      return <Redirect to={`/`} auth={authProps} />
    } else if (onlyManagePaginationAPI && !authProps.userState.policy.canManagePaginationAPI && !authProps.userState.isAdmin) {
      return <Redirect to={`/`} auth={authProps} />
    } else if (onlyBilling && (authProps.userState.type !== 'billing' && !authProps.userState.isAdmin)) {
      return <Redirect to={`/`} auth={authProps} />
    } else if (onlyGeox && (!authProps.userState.policy.canManageGeoxRules && !authProps.userState.isAdmin)) {
      return <Redirect to={`/`} auth={authProps} />
    } else if (onlyManageLabels && !authProps.userState.policy.canManageLabels && !authProps.userState.isAdmin) {
      return <Redirect to={`/`} auth={authProps} />
    } else if (isLogin) {
      return <Redirect to={`/${redirectPath}`} auth={authProps} />
    } else {
      return component
    }
  }
  // se ti stai autenticando, non mostrare niente, intanto aspetta
  else if (authProps.userState.isAuthenticating) {
    return <LoadingPage />
  }

  // se non sei autenticato, vai a login
  else {
    if (!isLogin) {
      const currentUrl = window.location.pathname + window.location.search;
      sessionStorage.setItem("redirect", currentUrl)
      return <Redirect to={`/${redirectPath}`} auth={authProps} />
    }
    else {
      return <Login auth={authProps} />
    }
  }
}


function AppLayout({ children, authProps, isNavigationExpanded, setIsNavigationExpanded, handleToggleHeaderMenu, layoutRef }) {
  const location = useLocation();
  const { setActiveService } = React.useContext(ServiceContext);

  React.useEffect(() => {
    if (location.pathname.startsWith('/labels')) {
      setActiveService('labels');
    } else {
      setActiveService('pagination');
    }
  }, [location.pathname, setActiveService]);

  return (
    <Box
      ref={layoutRef}
      sx={{
        position: 'relative',
        display: 'flex',
        overflow: 'hidden',
        height: '100vh',
        width: '100%',
      }}
    >
      <DashboardHeader
        auth={authProps}
        logo={logo}
        title=""
        menuOpen={isNavigationExpanded}
        onToggleMenu={handleToggleHeaderMenu}
      />

      <DashboardSidebar
        auth={authProps}
        expanded={isNavigationExpanded}
        setExpanded={setIsNavigationExpanded}
        container={layoutRef?.current ?? undefined}
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
        <Toolbar sx={{ displayPrint: 'none' }} />

        <Box component="main" sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
}